import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FaCamera } from "react-icons/fa";
const BoatGalleryModal = ({ isOpen, onClose, images, onCameraClick }) => {
  if (!images || images.length < 5) return null;

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size="lg"
      centered
    >
      <h2
        style={{
          marginBottom: '10px',
          textAlign: 'center',
          fontFamily: 'Arial, sans-serif',
        }}
      >
        Add/Edit Vessel Gallery
      </h2>
      <Modal.Body>
        <div className="container-fluid">
          <div className="row">
            {/* Left: Large image */}
            <div className="col-md-6 mb-3 mb-md-0">
              <img
                src={images[0]}
                alt="Main"
                className="img-fluid rounded w-100 h-100 object-fit-cover"
                style={{ objectFit: 'cover' }}
              />
              <Button
                variant=""
                size="sm"
                className="me-2"
                style={{
                  color: 'white',
                  position: 'absolute',
                  bottom: '10px',
                  right: '10px',
                  backgroundColor: 'transparent !important',
                  border: 'none',
                  fontSize: '1.5rem',
                }}
                onClick={() => onCameraClick(0)}
              >
                <FaCamera className="me-1" />
              </Button>
            </div>

            {/* Right: 2x2 smaller images */}
            <div className="col-md-6 d-grid gap-2">
              <div className="row g-2">
                {images.slice(1, 5).map((img, idx) => (
                  <div
                    key={idx}
                    className="col-6 position-relative"
                  >
                    <img
                      src={img}
                      alt={`Sub ${idx + 1}`}
                      className="img-fluid rounded w-100"
                      style={{ objectFit: 'cover', minHeight: '150px' }}
                      onError={(e) => {
                        e.target.onerror = null; // Prevent infinite loop
                        e.target.src = '/path/to/default-image.png'; // Set default image path
                      }}
                    />
                    <Button
                      variant=""
                      size="sm"
                      className="me-2"
                      style={{
                        color: 'white',
                        position: 'absolute',
                        bottom: '0px',
                        right: '-5px',
                        backgroundColor: 'transparent',
                        border: 'none',
                        fontSize: '1.5rem',
                      }}
                      onClick={() => onCameraClick(idx + 1)}
                    >
                      <FaCamera className="me-1" />
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onClose}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BoatGalleryModal;
